export function secondsToHours(seconds: number) {
	const h = Math.floor(seconds / 3600);
	const m = Math.floor((seconds % 3600) / 60);
	const s = Math.floor((seconds % 3600) % 60);

	return parseFloat(`${h}.${m}`);
}

export function secondsToMinutes(seconds: number) {
	return seconds / 60;
}
